import { Component, OnInit, ViewChild, ElementRef, Renderer2, AfterContentChecked } from '@angular/core';
import { AlertMessageService, AdobeAnalyticsService } from '../../cfet-core';

@Component({
    selector: 'app-alert-info',
    templateUrl: './alert-info.component.html',
    styleUrls: ['./alert-info.component.scss'],
    standalone: false
})
export class AlertInfoComponent implements OnInit, AfterContentChecked {

  showInfo: boolean;
  messages = [];
  flag: boolean;
  showInfoLink = { anchorLink: '', anchorText: '' };
  showHideCloseIcon = false;
  @ViewChild('closeBtn') closeBtnElement: ElementRef;
  @ViewChild('hyperLink') private hyperLink;

  constructor(private alertMessageService: AlertMessageService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private renderer: Renderer2) { }

  ngOnInit () {
    this.alertMessageService.showInfo.subscribe((flag) => {
      if (flag !== null) {
        this.showInfo = flag;
      }
      if (this.showInfo) {
        this.flag = true;
      }
    });
    this.alertMessageService.infoMessages.subscribe((messages) => {
      this.messages = [];
      if (messages) {
        if (Array.isArray(messages)) {
          this.messages = messages;
        } else {
          this.messages.push(messages);
        }
      }
    });
    this.alertMessageService.showInfoLink.subscribe((showInfoLink) => {
      if (showInfoLink !== null) {
        this.showInfoLink = showInfoLink;
      }
    });
    this.alertMessageService.showHideClose.subscribe((val) => {
      this.showHideCloseIcon = val;
    });
  }

  ngAfterContentChecked () {
    if (this.closeBtnElement && this.flag) {
      this.renderer.selectRootElement(this.closeBtnElement.nativeElement).focus();
      this.flag = false;
    }
  }

  toggle (val) {
    this[val] = !this[val];
  }

  registerNow (url) {
    window.location.href = url;
  }

  sonarFix (name) {
    this[name].nativeElement.href = 'javascript:void(0)';
  }

  adobeAnalyticsLinkClickEvent (eventcode?: string, linkname?: string, desturl?: string) {
    const successEventData: any = {
      successflag: '1',
      eventAction: 'linkclick',
      statusmessage: '',
      errortype: '',
      linkname: linkname,
      linkPosition: 'Body',
      destUrl: desturl,
      eventCode: eventcode
    };
    this.adobeAnalyticsService.sendCDLEvent(successEventData, '');
  }

}
